import { createElementIdSlice } from '../utils/action/createElementSlice';
export const SliderState = createElementIdSlice({
    elementName: 'slider',
    initialState: {},
    reducers: {},
});
